import React, { useState, useEffect } from "react";
import "../../../ReactKaamvalaWebsite/Pages/PricePlans/PricePlans.css";
import { Link, useNavigate } from "react-router-dom";
import vector from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/Vector.svg";
import awardframe from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/awardframe.svg";
import zomato from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/zomato.svg";
import urban from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/urbancompany.svg";
import udaan from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/udaan.svg";
import ola from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ola.svg";
import motor from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/tatamotor.svg";
import swiggy from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/swiggy.svg";
import hdfc from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/hdfc.svg";
import licious from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/licious.svg";
import frequent from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/frequent.webp";
import star from "../../../ReactKaamvalaWebsite/assets/image/star.svg";
import brain from "../../../ReactKaamvalaWebsite/assets/image/whyimage.svg";
import business from "../../../ReactKaamvalaWebsite/assets/image/business.svg";
import headPhone from "../../../ReactKaamvalaWebsite/assets/image/headPhone.svg";
import reachmore from "../../../ReactKaamvalaWebsite/assets/image/reachmorecandidate.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
const testimonials = [
  {
    id: 1,
    quote: "Out Standing services",
    text: "Kaamvala has greatly contributed to our hiring success. Their professional approach is impressive. Excited for ongoing partnership.",
    author: "Raunak Srivastak",
    position: "Field Sales",
    rating: 5,
  },
  {
    id: 2,
    quote: "Fantastic hiring platform",
    text: "Kaamvala has been crucial in fulfilling our recruitment needs professionally. We anticipate continued support and success.",
    author: "Faizaan Ahmad",
    position: "Machine Operator",
    rating: 5,
  },
  {
    id: 3,
    quote: "Amazing hiring experience",
    text: "Kaamvala has been instrumental in meeting our hiring needs with a professional approach. Looking forward to continued support.",
    author: "Aman Kumar",
    position: "Lab Technician",
    rating: 4,
  },
  {
    id: 4,
    quote: "Excellent recruitment platform",
    text: "Kaamvala has consistently met our hiring requirements with professionalism. We appreciate their support and look forward to more collaboration.",
    author: "Shivam Yadav",
    position: "Marketing",
    rating: 5,
  },
  {
    id: 5,
    quote: "Outstanding service",
    text: "Kaamvala has greatly contributed to our hiring success. Their professional approach is impressive. Excited for ongoing partnership.",
    author: "Raunak Srivastav",
    position: "Field Sales",
    rating: 5,
  },
  {
    id: 6,
    quote: "Fantastic hiring platform",
    text: "Kaamvala has been crucial in fulfilling our recruitment needs professionally. We anticipate continued support and success.",
    author: "Rahul Singh",
    position: "Department Head",
    rating: 4,
  },
];

const plans = {
  monthly: [
    {
      name: "Free Plan",
      price: "0",
      period: "/Week",
      features: [
        "Job active for 15 days",
        "1 posts/month",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
    {
      name: "Cool Vacancy",
      price: "249",
      period: "/monthly",
      save: "10%",
      features: [
        "Job active for 30 days",
        "5 posts/month",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
    {
      name: "Smooth Vacancy",
      price: "649",
      period: "/monthly",
      save: "10%",
      features: [
        "Job active for 90 days",
        "10 posts/month",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
    {
      name: "Urgent Vacancy",
      price: "1299",
      period: "/monthly",
      save: "10%",
      features: [
        "Job active for 90 days",
        "15 posts/month",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
  ],
  yearly: [
    {
      name: "Urgent Vacancy",
      price: "15588",
      period: "/yearly",
      save: "10%",
      features: [
        "Job active for 90 days",
        "15 posts/year",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
    {
      name: "Smooth Vacancy",
      price: "7788",
      period: "/yearly",
      save: "10%",
      features: [
        "Job active for 90 days",
        "10 posts/year",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
    {
      name: "Cool vacancy",
      price: "2988",
      period: "/yearly",
      save: "10%",
      features: [
        "Job active for 30 days",
        "15 posts/year",
        "5 members",
        "WhatsApp Notifications",
        "Higher visibility",
        "Immediate hiring tag",
      ],
      featured: true,
    },
  ],
};

const PricePlans = () => {
  const [formData, setFormData] = useState({
    phone: "",
    company: "",
    openings: "",
  });
  const navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("monthly");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { phone, company, openings } = formData;
    if (!phone || !company || !openings) {
      setSubmitted(true);
    } else {
      alert("Form submitted!");
      setSubmitted(false);
    }
  };

  return (
    <>
      <div id="plans">
        <section className="pricing_plans">
          <div className="container">
            <div className="row justify-content-center align-items-center m-auto d-flex">
              <div className="col-md-6 col-lg-6">
                <div className="pricing_plans_container">
                  <div className="pricing_plans_title">
                    <h6>Pricing Plans</h6>
                  </div>
                  <div className="pricing_text">
                    <span>To start hiring, please choose one of our plans</span>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-6
            "
              >
                <div className="pricing_plans_container2">
                  <div className="pricing_text">
                    <span>For any further queries , contact us</span>
                  </div>
                  <p className="pricing_call">*** **** *128</p>
                </div>
              </div>
            </div>
          </div>

          <div className="pricing-section">
            <div className="pricing-header">
              {/* <h2>Pricing Plans</h2> */}
              <div className="tab-switcher">
                <button
                  className={`tab-btn ${
                    activeTab === "monthly" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("monthly")}
                >
                  Monthly Plans
                </button>
                <button
                  className={`tab-btn ${
                    activeTab === "yearly" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("yearly")}
                >
                  Yearly Plans
                </button>
              </div>
            </div>

            <div className="pricing-cards">
              {plans[activeTab].map((plan, index) => (
                <div
                  key={index}
                  className={`pricing-card ${plan.featured ? "featured" : ""}`}
                >
                  <div className="card-header">
                    <h3>{plan.name}</h3>
                    <div className="price">
                      <span className="amount">{plan.price}</span>
                      <span className="period">{plan.period}</span>
                    </div>
                  </div>
                  <ul className="features">
                    {plan.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  <button
                    className="choose-plan-btn"
                    onClick={() => navigate("/company/subscription-plan")}
                  >
                    Choose Plan
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <section id="why-should">
        <div className="container py-5">
          <div className="survillence_title mb-4 mb-md-5">
            <h6>Why should I pay for Kaamvala?</h6>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="row g-4 justify-content-center">
                {/* Card 1 */}
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-10">
                  <div className="servillance_award_section1 h-100">
                    <div className="servillance d-flex justify-content-center mx-auto">
                      <img
                        src={awardframe}
                        className="d-block"
                        width="80"
                        height="80"
                        alt="1 Cr+ Candidate to choose from"
                        loading="lazy"
                      />
                    </div>
                    <div className="servillance_award_text1 text-center mt-3 justify-content-center m-auto py-3">
                      <h3>
                        1 Cr+ <span>Candidate to choose from</span>
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-10">
                  <div className="servillance_award_section1 h-100">
                    <div className="servillance d-flex justify-content-center mx-auto">
                      <img
                        src={business}
                        className="d-block"
                        width="80"
                        height="80"
                        alt="Hire Within 24hrs"
                        loading="lazy"
                      />
                    </div>
                    <div className="servillance_award_text1 text-center mt-3 justify-content-center m-auto py-3">
                      <h3>
                        <span>Hire Within</span> 48hrs
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-10">
                  <div className="servillance_award_section1 h-100">
                    <div className="servillance d-flex justify-content-center mx-auto">
                      <img
                        src={headPhone}
                        className="d-block"
                        width="80"
                        height="80"
                        alt="Priority Customer service"
                        loading="lazy"
                      />
                    </div>
                    <div className="servillance_award_text1 text-center mt-3 justify-content-center m-auto py-3">
                      <h3>
                        <span>Priority</span> Customer service
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Card 4 */}
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-10">
                  <div className="servillance_award_section1 h-100">
                    <div className="servillance d-flex justify-content-center mx-auto">
                      <img
                        src={reachmore}
                        className="d-block"
                        width="80"
                        height="80"
                        alt="Reach more candidates with Job Boosts"
                        loading="lazy"
                      />
                    </div>
                    <div className="servillance_award_text1 text-center mt-3 justify-content-center m-auto py-3">
                      <h3>
                        <span>Reach more candidates with</span> Job Boosts
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="top_companies_head col-md-12 text-center">
            <h1>Our Customer</h1>
          </div>
          <div className="landing-page-line my-2"></div>
          <div className="container">
            <div className="row all">
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={zomato}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>

              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={hdfc}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={motor}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={urban}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={ola}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={licious}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={udaan}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
              <div className="col-lg-3 col-md-4 client_industry justify-content-center mx-auto d-flex py-3">
                <img
                  src={swiggy}
                  alt="web and app development"
                  className="d-block"
                  width="260"
                  height="140"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="price-slider">
        <div className="container">
          <div className="my-4">
            <div className="container py-4 justify-content-center mx-auto">
              <div className="row">
                <div className="col-md-12">
                  <Swiper
                    slidesPerView={2}
                    spaceBetween={30}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      576: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        centeredSlides: false,
                      },

                      640: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                      },
                    }}
                    className="mySwiper"
                  >
                    {testimonials.map((testimonial) => (
                      <SwiperSlide key={testimonial.id}>
                        <div className="employee_review_box item mt-3">
                          <div className="employee_review_content">
                            <h6>{testimonial.quote}</h6>
                            <p>{testimonial.text}</p>
                          </div>
                          <div className="employee_review_box_img_box d-flex">
                            <div className="img_box_review">
                              <img
                                src={brain}
                                alt="Web and app development"
                                className="d-block image-fluid "
                                width="70"
                                height="80"
                              />
                            </div>
                            <div className="employee_review_designation ml-3">
                              <h6>{testimonial.author}</h6>
                              <p>{testimonial.position} </p>
                              <div className="employee_review_rating d-flex gap-1">
                                <img
                                  src={star}
                                  alt="Web and app development"
                                  width="20"
                                  height="20"
                                  className="d-block image-fluid"
                                />
                                <img
                                  src={star}
                                  alt="Web and app development"
                                  width="20"
                                  height="20"
                                  className="d-block image-fluid"
                                />
                                <img
                                  src={star}
                                  alt="Web and app development"
                                  width="20"
                                  height="20"
                                  className="d-block image-fluid"
                                />
                                <img
                                  src={star}
                                  alt="Web and app development"
                                  width="20"
                                  height="20"
                                  className="d-block image-fluid"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container my-5">
          <div className="row">
            <div className="col-md-5 col-lg-5">
              <div className="top_companies_head_employer col-md-12 text-center">
                <h2 className="">Frequently Asked Questions (Employer)</h2>
              </div>
              <div className="img_frequent_asked">
                <img
                  src={frequent}
                  className="d-block img-fluid"
                  alt="web and development"
                  loading="lazy"
                  data-opt-lazy-loaded="false"
                />
              </div>
            </div>
            <div className="col-md-7 col-lg-7">
              <div className="accordion faq_accordion" id="accordionExample">
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      How do I set up an employer account on kaamvala?
                    </button>
                  </h3>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      To create an account on Kaamvala, simply sign up with your
                      details and verify your phone number using an OTP. After
                      that, you can start posting jobs right away.
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      How do I begin hiring with Kaamvala ?
                    </button>
                  </h3>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      You can start hiring in three easy steps:
                      <ul>
                        <li className="list-disc ml-5">
                          <b className="bold">Post a Job:</b>
                          Register and post your job in under 5 minutes using
                          OTP for verification."
                        </li>
                        <li className="list-disc ml-5">
                          <b className="bold">Select a Hiring Plan: </b>
                          Select the hiring plan and proceed to payment.
                        </li>
                        <li className="list-disc ml-5">
                          Get Verified: "Our team will contact you for your
                          account verification."
                        </li>
                        <li className="list-disc ml-5">
                          <b className="bold">Accept Applications: </b>
                          Candidates will start approaching you after the
                          process of verification.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      How does Kaamvala help me find the most suitable
                      candidates quickly ?
                    </button>
                  </h3>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Kaamvala uses smart filters to make sure only candidates
                      who meet your job requirements can see and apply to your
                      job. This saves your time and ensures you get qualified
                      applicants.
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Can I edit or update my job post after it has been
                      published ?
                    </button>
                  </h3>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, you can easily edit or update your job post at any
                      time through your employer dashboard.
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      What payment options are available on Kaamvala ?
                    </button>
                  </h3>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Kaamvala accepts multiple payment methods including:
                    </div>
                    <ul className="faq-text faq-list">
                      <li className="list-disc ml-5">credit Card</li>
                      <li className="list-disc ml-5">Debit Card</li>
                      <li className="list-disc ml-5">Net Banking</li>
                      <li className="list-disc ml-5">UPI</li>
                      <li>Digital Wallets</li>
                    </ul>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      Can I get a GST invoice after making a purchase on
                      Kaamvala ?
                    </button>
                  </h3>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, Kaamvala provides a GST invoice after you purchase a
                      hiring plan. The invoice is sent to your email and can be
                      used to claim input tax credit. Make sure your GST number
                      is correct in your profile.
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSeven"
                      aria-expanded="false"
                      aria-controls="collapseSeven"
                    >
                      Is it possible to get a refund for my Kaamvala plan?
                    </button>
                  </h3>
                  <div
                    id="collapseSeven"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      If we fail to meet your hiring needs, you may be eligible
                      for a refund based on our policy. Refunds are not
                      available for job posts from placement agencies or
                      consultancies.
                    </div>
                  </div>
                </div>
                <div className="accordion-item faq_accordion_item">
                  <h3 className="accordion-header">
                    <button
                      className="accordion-button faq_accordion_button faq_heading collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEight"
                      aria-expanded="false"
                      aria-controls="collapseEight"
                    >
                      Does Kaamvala offer special rates for bulk hiring?
                    </button>
                  </h3>
                  <div
                    id="collapseEight"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, Kaamvala provides bulk hiring discounts if you need
                      to recruit more than ten employees at once. Please contact
                      our sales team for details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="getintouch">
        <div className="container">
          <div className="form-container">
            <h2 className="form-title">Do you need to get in touch with us?</h2>

            <p
              className="error-msg"
              style={{ display: submitted ? "block" : "none" }}
            >
              There was an error trying to send your message. Please try again
              later.
            </p>
            {submitted && (
              <div className="form-error">Please fill out this field.</div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-row1">
                <div className="form-group1">
                  <label>Phone Number</label>
                  <input
                    className="mera-form"
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter phone number"
                  />
                  {submitted && !formData.phone && (
                    <span className="field-error">
                      Please fill out this field.
                    </span>
                  )}
                </div>

                <div className="form-group1">
                  <label>Company Name</label>
                  <input
                    className="mera-form"
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Enter company name"
                  />
                  {submitted && !formData.company && (
                    <span className="field-error">
                      Please fill out this field.
                    </span>
                  )}
                </div>

                <div className="form-group1">
                  <label>Number of Openings</label>
                  <input
                    className="mera-form"
                    type="text"
                    name="openings"
                    value={formData.openings}
                    onChange={handleChange}
                    placeholder="Enter number of openings"
                  />
                  {submitted && !formData.openings && (
                    <span
                      className="field-error"
                      style={{
                        textAlign: "left",
                      }}
                    >
                      Please fill out this field.
                    </span>
                  )}
                </div>
              </div>

              <div className="form-submit">
                <button type="submit">Request a Callback</button>
              </div>
              {submitted && (
                <div
                  className="form-error"
                  style={{
                    textAlign: "left",
                  }}
                >
                  One or more fields have an error. Please check and try again.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};
export default PricePlans;
